<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import wootConstants from 'dashboard/constants/globals';

const store = useStore();
const { t } = useI18n();

const currentChat = computed(() => store.getters.getSelectedChat);

const isResolved = computed(
  () => currentChat.value.status === wootConstants.STATUS_TYPE.RESOLVED
);

const label = computed(() =>
  isResolved.value
    ? t('CONVERSATION.HEADER.REOPEN_ACTION')
    : t('CONVERSATION.HEADER.RESOLVE_ACTION')
);

const toggleResolve = () => {
  const status = isResolved.value
    ? wootConstants.STATUS_TYPE.OPEN
    : wootConstants.STATUS_TYPE.RESOLVED;
  store
    .dispatch('toggleStatus', {
      conversationId: currentChat.value.id,
      status,
    })
    .then(() => useAlert(t('CONVERSATION.CHANGE_STATUS')));
};
</script>

<template>
  <button
    type="button"
    class="resolve--button"
    :class="isResolved ? 'is-reopen' : 'is-resolve'"
    @click="toggleResolve"
  >
    {{ label }}
  </button>
</template>

<style scoped lang="scss">
.resolve--button {
  height: 32px;
  padding: 0 14px;
  border-radius: 2px;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005em;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
}

// Open conversation: outlined SUMO blue — white background, blue border + text.
.is-resolve {
  color: #006ce0;
  background: #ffffff;
  border: 1px solid #006ce0;

  &:hover {
    background: #f0f6ff;
    border-color: #004fa3;
    color: #004fa3;
  }
}

// Resolved conversation: subtle light button to reopen.
.is-reopen {
  color: #0e243b;
  background: #ffffff;
  border: 1px solid #dee2e6;

  &:hover {
    background: #f5f6f8;
  }
}
</style>
